import { render, staticRenderFns } from "./cabinet-ktru-favorites-list.vue?vue&type=template&id=00a533ec&scoped=true&"
import script from "./cabinet-ktru-favorites-list.vue?vue&type=script&lang=js&"
export * from "./cabinet-ktru-favorites-list.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-ktru-favorites-list.vue?vue&type=style&index=0&id=00a533ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a533ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a533ec')) {
      api.createRecord('00a533ec', component.options)
    } else {
      api.reload('00a533ec', component.options)
    }
    module.hot.accept("./cabinet-ktru-favorites-list.vue?vue&type=template&id=00a533ec&scoped=true&", function () {
      api.rerender('00a533ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/ktru/favorites/cabinet-ktru-favorites-list.vue"
export default component.exports